import { Ref, ref, watch } from 'vue'

const storageKey = 'viewerEbomTreeWidth'
export const DEFAULT_EBOM_TREE_WIDTH = 260
export const MIN_EBOM_TREE_WIDTH = 200

function readInitial(): number {
  const saved = Number(window.localStorage.getItem(storageKey))
  return saved >= MIN_EBOM_TREE_WIDTH ? saved : DEFAULT_EBOM_TREE_WIDTH
}

const width = ref(readInitial())
watch(width, (v) => window.localStorage.setItem(storageKey, String(v)))

export default function useEbomTreeWidth(): { width: Ref<number> } {
  return { width }
}
